import * as React from 'react';
export * from './components';
var defaults = {
    setLocale: function (locale) { return void 0; },
    formatDate: function (date, options) { return ''; },
    formatDateString: function (dateString, options) { return ''; },
    formatText: function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return '';
    },
    getWeekData: function () { return ({ firstDay: '' }); },
    parseLocalDateString: function (dateString, options) { return ''; }
};
export var LocalizationContext = React.createContext(defaults);
export var useLocalization = function () { return React.useContext(LocalizationContext); };
//# sourceMappingURL=index.js.map